<template>
  <section class="hero">
    <div class="hero-bg"></div>
    <div class="container" style="position:relative;">
      <h1 class="fade-up fade-up-delay-1">
        {{ $t('hero.title') }}<br/><em>{{ $t('hero.titleEm') }}</em>
      </h1>
      <p class="hero-sub fade-up fade-up-delay-2">
        {{ $t('hero.sub') }}
      </p>
      <div class="hero-cta fade-up fade-up-delay-3">
        <router-link :to="{ name: 'signUp' }" class="btn-primary btn-large">
          {{ $t('hero.ctaPrimary') }}
          <svg viewBox="0 0 24 24" style="width:16px;height:16px;stroke-width:2.5;"><path d="M5 12h14M12 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </router-link>
        <a href="#how-it-works" class="btn-outline" @click.prevent="$router.push('/how')">{{ $t('hero.ctaSecondary') }}</a>
      </div>
      <!-- App preview screenshot -->
      <div class="hero-illustration fade-up fade-up-delay-3" style="transition-delay:0.4s;">
        <div class="app-preview">
          <div class="app-preview-bar">
            <div class="app-preview-dot dot-red"></div>
            <div class="app-preview-dot dot-yellow"></div>
            <div class="app-preview-dot dot-green"></div>
            <div class="app-preview-url">{{ $t('hero.preview.url') }}</div>
          </div>
          <div class="app-screenshot-wrap">
            <img src="/tasks.png" class="app-screenshot-img" alt="Kordelo — task board" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HeroSection',
  }
</script>

<style scoped>
.hero {
  padding-top: 120px;
  padding-bottom: 100px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 60% at 50% -10%, rgba(91, 141, 184, 0.12) 0%, transparent 70%),
              radial-gradient(ellipse 40% 40% at 10% 80%, rgba(123, 175, 150, 0.10) 0%, transparent 60%),
              radial-gradient(ellipse 40% 40% at 90% 70%, rgba(232, 180, 160, 0.10) 0%, transparent 60%);
  pointer-events: none;
}

.hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(91, 141, 184, 0.10);
  color: var(--primary-dark);
  border: 1px solid rgba(91, 141, 184, 0.22);
  padding: 0.35rem 1rem;
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
}

.hero-eyebrow span { width: 6px; height: 6px; background: var(--primary); border-radius: 50%; display: inline-block; }

.hero h1 {
  font-size: clamp(2.4rem, 5vw, 3.8rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: var(--text);
  max-width: 740px;
  margin: 0 auto 1.2rem;
}

.hero h1 em {
  font-style: normal;
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-sub {
  font-size: 1.15rem;
  color: var(--text-muted);
  max-width: 520px;
  margin: 0 auto 2.5rem;
  line-height: 1.7;
}

.hero-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 2.5rem;
}

.hero-note {
  font-size: 0.8rem;
  color: var(--text-light);
}

.hero-illustration {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}

.app-preview {
  background: var(--bg-card);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  position: relative;
}

.app-preview-bar {
  background: #F0EDE9;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.app-preview-dot {
  width: 11px; height: 11px;
  border-radius: 50%;
}

.dot-red { background: #FCA5A5; }
.dot-yellow { background: #FCD34D; }
.dot-green { background: #6EE7B7; }

.app-preview-url {
  flex: 1;
  background: white;
  border-radius: 6px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  color: var(--text-light);
  margin: 0 8px;
}

.app-screenshot-wrap {
  overflow: hidden;
  line-height: 0;
}

.app-screenshot-img {
  width: 100%;
  display: block;
  clip-path: inset(0 0 30% 0);
  margin-bottom: -25%;
}

@media (max-width: 700px) {
  .hero-cta { flex-direction: column; align-items: center; }

  .app-screenshot-wrap { max-height: 220px; }

  .app-screenshot-img {
    clip-path: none;
    margin-bottom: 0;
    height: 220px;
    object-fit: cover;
    object-position: top left;
  }
}

@media (max-width: 480px) {
  .app-preview { display: none; }
}
</style>
